import { useEffect, useState } from "react";
import classes from "./classes.module.scss";

type IProps = {
	src: string | null;
	alt: string;
	className?: string;
};

export default function LazyImage(props: IProps) {
	const [src, setSrc] = useState<string | null>(null);
	const onePixel = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjYGBkZAAAAAoAAx9k7/gAAAAASUVORK5CYII=";

	useEffect(() => {
		if (!props.src) {
			setSrc(null);
			return;
		}
		const img = new Image();
		img.onload = () => setSrc(props.src);
		img.src = props.src;
	}, [props.src]);

	if (src) {
		return <img src={src as string} alt={props.alt} className={classes["fade-in"]!.concat(" ", props.className ?? "")} />;
	}
	return <img src={onePixel} alt={props.alt} className={props.className} />;
}
